import styled from 'styled-components';
import { colors, screenSize } from 'theme';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
},
  defaultProps = {
    color: colors.orange,
  };

const StyledBurger = styled.button`
  display: flex;
  position: absolute;
  top: 32px;
  right: 26px;
  flex-direction: column;
  justify-content: space-around;
  width: 32px;
  height: 32px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: visible;
  z-index: 10;

  &:focus {
    outline: none;
  }

  @media only screen and (min-width: ${screenSize.nav}) {
    display: none;
  }
`;
const InnerChild = styled.div`
    width: 32px;
    height: 3px;
    background: ${({ open }) => open ? colors.beige : colors.orange};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;

    :first-child {
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    :nth-child(2) {
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    :nth-child(3) {
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
`;



const Burger = (props) => {
  const { open, setOpen } = props;

  const _handleSetOpen = (open) => {
    setOpen(!open)
  }

  return (
    <StyledBurger onClick={() => _handleSetOpen(open)}>
      <InnerChild open={open} />
      <InnerChild open={open} />
      <InnerChild open={open} />
    </StyledBurger>
  )
};

Burger.propTypes = propTypes;
Burger.defaultProps = defaultProps;
export default Burger;